/*  Tom Cuypers
 *  Kiswe 2019
 *  convertion of epoch to/from date taking zones into account
 */


export const dateToUTC = (date: Date) => {
  return date.getTime() // + date.getTimezoneOffset() * 60 * 1000
}

export const utctoDate = (epoch: number) => {
  const date = new Date(0)
  date.setUTCMilliseconds(epoch /*- date.getTimezoneOffset() * 60 * 1000*/ )
  return date
}
